angular.module('shiftTraderApp.constants', [])
  .value('regexStrings', { //jshint ignore:line
    email: "[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-z0-9](?:[A-z0-9-]*[a-z0-9])?\\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?", // jshint ignore:line
    phone: "^([0-9]( |-)?)?(\\(?[0-9]{3}\\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$", // jshint ignore:line
    money: "^([1-9]{1}[0-9]{0,2}(\,[0-9]{3})*(\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|(\.[0-9]{1,2})?)$" // jshint ignore:line
  }) // jshint ignore:line
  .value('saNoteDefaultVisibleReplies', 1)
  .value('saNoteReplyAbbreviationThreshold', 3)  // Max number of note replies to display by default before collapsing them down
  .value('saNotePermissionLevels', {
        0: {
          label: 'Public',
          description: 'Everyone will be able to view this note.',
          iconClass: 'icon-globe',
          id: 0
        },
        1: {
          label: 'Management',
          description: 'Only management and admins will be able to view this note.',
          iconClass: 'icon-user-md',
          id: 1
        },
        2: {
          label: 'Admins',
          description: 'Only admins will be able to view this note.',
          iconClass: 'icon-star',
          id: 2
        }
      })
  .value('saNoteMessageParseDelay', 250)
  .value('saMediaExpirationSeconds', 30)
  .value('saMediaLinkMatchers', {
    youtube: {
      check:  /^(https?\:\/\/)?(www\.)?youtu(\.be\/|be\.com\/)*/gi,
      capture: /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/i
    },
    vimeo: {
      capture: /^(?:https?\:\/\/)?(?:(?:www\.)?vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)*/i
    }
  })
  .value('saNoteShowContextMenu', false)
  .value('EventStreamNames', {
    mwpUpdates: 'sa:manageWorkPeriods:updates',
    mwpCollapseChange: 'sa:manageWorkPeriods:collapseChangeUpdates',
    barIntervalUpdates: 'sa:manageWorkPeriods:barIntervalUpdates',
    notesOverlayContext: 'sa:notesOverlayContext'
  })
  .value('saNoteShowContextMenu', false)
  .value('saHomeBackgroundEnabled', false);
